!function(){"use strict";
  var dl=function(o){(window.dataLayer=window.dataLayer||[]).push(o);};
  var productMeta=function(){
    var p=(window.ShopifyAnalytics&&window.ShopifyAnalytics.meta||{}).product||{};
    return{item_id:p.sku||String(p.id||""),item_name:p.title||document.title,
           price:p.price?(p.price/100).toFixed(2):"0.00",
           item_category:p.type||"",item_brand:p.vendor||""};
  };
  var itemsFromCartData=function(d){
    if(!d||!d.items)return[];
    return d.items.slice(0,1).map(function(i){
      return{item_id:i.sku||String(i.id),item_name:i.title,
             price:(i.price/100).toFixed(2),item_category:i.product_type||"",
             item_brand:i.vendor||"",quantity:i.quantity};
    });
  };
  /* ── Fetch intercept: fires AFTER successful /cart/add response ── */
  var _fetch=window.fetch;
  window.fetch=function(){
    var args=arguments;
    var url=(args[0]&&args[0].toString?args[0].toString():"");
    if(url.indexOf("/cart/add")!==-1){
      return _fetch.apply(this,args).then(function(res){
        var cloned=res.clone();
        cloned.json().then(function(d){
          if(res.ok){
            dl({event:"add_to_cart",funnel_step_number:3.5,funnel_step_label:"add_to_cart",
               ecommerce:{currency:"USD",items:itemsFromCartData({items:[d]})}});
          }
        }).catch(function(){
          if(res.ok) dl({event:"add_to_cart",funnel_step_number:3.5,funnel_step_label:"add_to_cart",
                         ecommerce:{items:[productMeta()]}});
        });
        return res;
      });
    }
    return _fetch.apply(this,args);
  };
  /* ── XHR intercept for older Shopify themes ── */
  var _open=XMLHttpRequest.prototype.open, _send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this._url=u;return _open.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(){
    var xhr=this;
    if(xhr._url&&xhr._url.indexOf("/cart/add")!==-1){
      xhr.addEventListener("load",function(){
        if(xhr.status>=200&&xhr.status<300){
          try{var d=JSON.parse(xhr.responseText);
            dl({event:"add_to_cart",funnel_step_number:3.5,funnel_step_label:"add_to_cart_xhr",
               ecommerce:{currency:"USD",items:itemsFromCartData({items:[d]})}});
          }catch(e){
            dl({event:"add_to_cart",funnel_step_number:3.5,funnel_step_label:"add_to_cart_xhr",
               ecommerce:{items:[productMeta()]}});
          }
        }
      });
    }
    return _send.apply(this,arguments);
  };

  /* ── begin_checkout: event delegation catches dynamic cart drawer buttons ── */
  var _checkoutFired=false;
  var CHECKOUT_SEL='[name="checkout"],[data-cart-checkout],input[name="checkout"],button[name="checkout"],a[href="/checkout"],a[href*="/checkouts/"],button[data-action="checkout"],.cart__checkout-button,.cart-drawer__checkout';
  function fireBeginCheckout(){
    if(_checkoutFired)return;
    _checkoutFired=true;
    // Fetch live cart data to include items in the event
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      dl({
        event:"begin_checkout",
        funnel_step_number:4.5,
        funnel_step_label:"begin_checkout",
        ecommerce:{
          value:(cart.total_price/100).toFixed(2),
          currency:cart.currency||"USD",
          items:(cart.items||[]).map(function(i){
            return{
              item_id:i.sku||String(i.variant_id),
              item_name:i.title,
              price:(i.price/100).toFixed(2),
              quantity:i.quantity,
              item_category:i.product_type||"",
              item_brand:i.vendor||""
            };
          })
        }
      });
    }).catch(function(){
      dl({event:"begin_checkout",funnel_step_number:4.5,funnel_step_label:"begin_checkout"});
    }).finally(function(){
      // Allow re-fire after 5s so a second checkout attempt can still track
      setTimeout(function(){_checkoutFired=false;},5000);
    });
  }

  // Event delegation on document catches buttons added dynamically (cart drawer, etc.)
  document.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest(CHECKOUT_SEL)){
      fireBeginCheckout();
    }
  },true);

  // MutationObserver: attach click listener to any checkout button injected into DOM
  // (belt-and-suspenders for themes that prevent bubbling)
  if(window.MutationObserver){
    var obs=new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType!==1)return;
          var els=[];
          try{els=Array.prototype.slice.call(node.querySelectorAll?node.querySelectorAll(CHECKOUT_SEL):[]);}catch(e){}
          if(node.matches&&node.matches(CHECKOUT_SEL))els.push(node);
          els.forEach(function(el){
            el.addEventListener("click",fireBeginCheckout,{once:true});
          });
        });
      });
    });
    obs.observe(document.body||document.documentElement,{childList:true,subtree:true});
  }

  // Also attach at DOMContentLoaded for static checkout buttons on cart page
  document.addEventListener("DOMContentLoaded",function(){
    document.querySelectorAll(CHECKOUT_SEL).forEach(function(el){
      el.addEventListener("click",fireBeginCheckout,{once:true});
    });
  });

  /* ── view_cart: cart drawer open ── */
  document.addEventListener("click",function(e){
    var t=e.target;
    if(t.closest('[data-cart-toggle],[data-open-cart],[aria-label*="cart"],[href="/cart"]')){
      setTimeout(function(){
        dl({event:"view_cart",funnel_step_number:4,funnel_step_label:"view_cart"});
      },300);
    }
  });
}();